<template>
<div>
  tool
</div>
</template>

<script>
export default {
  name: "Tool"
}
</script>

<style scoped>

</style>